import ScreenReaderText from "./ScreenReaderText";

export default ScreenReaderText;